import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { competition } from './competition.module';
import { participant } from './participant.module';
// import { router } from '../router';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    competition,
    participant
  },
  mutations: {
    initialiseStore(state) {
      console.log("Check if store is in localStorage")
      // Check if the ID exists
      if(localStorage.getItem('store')) {
        console.log("Loading store from localStorage")
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        );
        // this.$store.dispatch('auth/setSelectedCompetition', this.$store.state.auth.selectedCompetition);
      } else {
        console.log("No store in localStorage");
      }
    }
  }
});

